// Данный файл - лишь собрание подключений готовых компонентов.
// Рекомендуется создавать отдельный файл в папке components и подключать все там

// Определение операционной системы на мобильных
import { model } from "./functions/model-sprite";
let animationCanvas = document.querySelectorAll(".js-animationCanvas");

animationCanvas.forEach(element => {
  model(element);
});


import { preloader } from "./functions/loader";

import marquee from 'vanilla-marquee'

import Choices from 'choices.js';



const multiSelect = () => {
  const elements = document.querySelectorAll('.js-choice');
  elements.forEach(el => {
    const choices = new Choices(el, {
      shouldSort: false,
      silent: false,
      placeholderValue: true,
      searchPlaceholderValue: null,
      noResultsText: '',
      position: 'bottom',
      searchEnabled: false,
      searchChoices: false,
      allowHTML: true,
      canSearch: false,
      itemSelectText: '',
      classNames: {
        containerOuter: 'choices',
        containerInner: 'choices__inner callback__field',
        input: 'choices__input',
        inputCloned: 'choices__input--cloned',
        list: 'choices__list',
        listItems: 'choices__list--multiple',
        listSingle: 'choices__list--single',
        listDropdown: 'choices__list--dropdown',
        item: 'choices__item',
        itemSelectable: 'choices__item--selectable',
        itemDisabled: 'choices__item--disabled',
        itemChoice: 'choices__item--choice',
        placeholder: 'choices__placeholder',
        group: 'choices__group',
      }
    })
  });
};

multiSelect();

//const elementChoices = document.querySelector('.js-choice');

/* if(elementChoices){
  for (var i = 0; i < elementChoices.length; i++ ) {
    const ChoicesEL = new Choices(elementChoices[i], {
      silent: false,
      placeholderValue: null,
      searchPlaceholderValue: null,
      noResultsText: '',
      searchEnabled: false,
      searchChoices: false,
      allowHTML: true,
      canSearch: false,
      itemSelectText: '',
      classNames: {
        containerOuter: 'choices',
        containerInner: 'choices__inner callback__field',
        input: 'choices__input',
        inputCloned: 'choices__input--cloned',
        list: 'choices__list',
        listItems: 'choices__list--multiple',
        listSingle: 'choices__list--single',
        listDropdown: 'choices__list--dropdown',
        item: 'choices__item',
        itemSelectable: 'choices__item--selectable',
        itemDisabled: 'choices__item--disabled',
        itemChoice: 'choices__item--choice',
        placeholder: 'choices__placeholder',
        group: 'choices__group',
      }
    })
  }
  
} */


require("fslightbox");
// fsLightbox.open();


const callbackLeft = document.querySelector(".callback__left");
const callbackRight = document.querySelector(".callback__right");
const callbackSuccess = document.querySelector(".callback__success");

if (document.querySelector(".callback__again")) {
  document.querySelector(".callback__again").addEventListener("click", function () {
    callbackLeft.classList.remove("callback_hidden");
    callbackRight.classList.remove("callback_hidden");
    callbackSuccess.classList.add("callback_hidden");
  });
}

document.querySelectorAll('.js-form-submit').forEach(function (button) {
  button.addEventListener('click', function (event) {
    event.preventDefault();
    var form = button.closest('form');
    var inputs = form.querySelectorAll('input');
    var selects = form.querySelectorAll('select');

    // Удаляем все существующие сообщения об ошибках
    form.querySelectorAll('.error-input').forEach(function (error) {
      error.remove();
    });

    var formError = false;
    inputs.forEach(function (input) {
      if (input.type === 'email' && !isValidEmail(input.value) && input.value) {
        var errorParagraph = document.createElement('p');
        var wrappError = input.closest(".callback__field-wrapper");
       
        errorParagraph.textContent = input.dataset.error;
        errorParagraph.classList.add('error-input');
        //input.insertAdjacentElement('afterend', errorParagraph);
        wrappError.querySelector(".error-wrapper").appendChild(errorParagraph);

        formError = true;
      } else if (!input.value && input.hasAttribute('required')) {
        var errorParagraph = document.createElement('p');
        var wrappError = input.closest(".callback__field-wrapper");
     
        errorParagraph.textContent = input.dataset.error;
        errorParagraph.classList.add('error-input');
        wrappError.querySelector(".error-wrapper").appendChild(errorParagraph);
        //input.insertAdjacentElement('afterend', errorParagraph);

        formError = true;
      }
    });

    selects.forEach(function (select) {
      if (!select.value && select.hasAttribute('required')) {
        var errorParagraph = document.createElement('p');
        var wrappError = select.closest(".callback__field-wrapper");
     
        errorParagraph.textContent = select.dataset.error;
        errorParagraph.classList.add('error-input');
        wrappError.querySelector(".error-wrapper").appendChild(errorParagraph);
        //input.insertAdjacentElement('afterend', errorParagraph);

        formError = true;
      }
    });

    if (!formError) {
      let formData = new FormData(form);
      let xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            callbackLeft.classList.add("callback_hidden");
            callbackRight.classList.add("callback_hidden");
            callbackSuccess.classList.remove("callback_hidden");

            form.reset();
          }
        }
      }

      xhr.open('POST', '/wp-admin/admin-ajax.php', true);
      xhr.send(formData);
    }
  });
});



function isValidEmail(email) {

  // Регулярное выражение для проверки корректности email-адреса
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

import { canvasBack } from "./functions/canvas-back";
canvasBack();


// import { mobileCheck } from "./functions/mobile-check";

import { product } from "./functions/product-sprite";
import { cursor } from "./functions/cursor";
import { viewport } from "./functions/viewport";

preloader();
cursor();
product();

viewport();

// Определение ширины экрана
// import { isMobile, isTablet, isDesktop } from './functions/check-viewport';
// if (isDesktop()) {
//   console.log('...')
// }




// Троттлинг функции (для ресайза, ввода в инпут, скролла и т.д.)
// import { throttle } from './functions/throttle';
// let yourFunc = () => { console.log('throttle') };
// let func = throttle(yourFunc);
// window.addEventListener('resize', func);

// Фикс фулскрин-блоков
// import './functions/fix-fullheight';

// Реализация бургер-меню
import { burger } from './functions/burger';

// Реализация остановки скролла (не забудьте вызвать функцию)
// import { disableScroll } from './functions/disable-scroll';

// Реализация включения скролла (не забудьте вызвать функцию)
// import { enableScroll } from './functions/disable-scroll';

// Реализация модального окна
import GraphModal from 'graph-modal';
const modal = new GraphModal();

// Реализация табов
// import GraphTabs from 'graph-tabs';
// const tabs = new GraphTabs('tab');

// Получение высоты шапки сайта (не забудьте вызвать функцию)
// import { getHeaderHeight } from './functions/header-height';

// Подключение плагина кастом-скролла
// import 'simplebar';

// Подключение плагина для позиционирования тултипов
// import { createPopper, right} from '@popperjs/core';
// createPopper(el, tooltip, {
//   placement: 'right'
// });

// Подключение свайпера

import Swiper from 'swiper/bundle';


const progressBlock = document.querySelector(".first-screen__slide_controller");

// import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Controller } from 'swiper';
// Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Controller]);

const swiper = new Swiper('.mySwiperFirst', {
  slidesPerView: 1,
  autoplay: {
    delay: 7000,
    disableOnInteraction: true
  },
  pagination: {
    el: ".first-screen-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".first-screen-button-next",
    prevEl: ".first-screen-button-prev",
  },
  on: {
    autoplayTimeLeft(s, time, progress) {
      // console.log(progress);

      //progressBlock.style.setProperty("--progress", 100-100*progress+"%");

      //   progressCircle.style.setProperty("--progress", 1 - progress);
      //   progressContent.textContent = `${Math.ceil(time / 1000)}s`;
    }
  }
});




const swiperSecond = new Swiper('.mySwiperSecond', {
  slidesPerView: 1,
  autoplay: {
    delay: 35000,
    disableOnInteraction: false
  },
  spaceBetween: 10,
  pagination: {
    el: ".advant-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


const swiperProducts = new Swiper('.mySwiperProducts', {
  slidesPerView: 'auto',
  spaceBetween: 13,
  scrollbar: {
    el: ".swiper-scrollbar",
    //hide: true,
    draggable: true,
  },
  mousewheel: true
})

const swiperProductsBurger = new Swiper('.mySwiperProductsBurger', {
  slidesPerView: 'auto',
  spaceBetween: 13,
  scrollbar: {
    el: ".swiper-scrollbar",
    //hide: true,
  },
})

const swiperAboutUs = new Swiper('.aboutUsSwiper', {
  slidesPerView: 1.1,
  spaceBetween: 10,
  autoplay: {
    delay: 35000,
    disableOnInteraction: false
  },
  navigation: {
    nextEl: '.aboutUsSwiper .swiper-button-next',
    prevEl: '.aboutUsSwiper .swiper-button-prev',
  },
  breakpoints: {
    600: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
  }
});

const swiperPresentation = new Swiper('.presentationsSwiper', {
  slidesPerView: 1.02,
  autoplay: {
    delay: 35000,
    disableOnInteraction: false
  },
  spaceBetween: 10,
  navigation: {
    nextEl: '.presentationsSwiper .swiper-button-next',
    prevEl: '.presentationsSwiper .swiper-button-prev',
  },
  breakpoints: {
    480: {
      slidesPerView: 1,
    },
  }
});


const swiperReviews = new Swiper('.reviewsSwiper', {
  enabled: true,
  // slidesPerView: 'auto',
  slidesPerView: 1.2,
  spaceBetween: 40,
  autoplay: {
    delay: 35000,
    disableOnInteraction: false
  },
  breakpoints: {
    480: {
      enabled: false,
    },
  }
});


const SwiperCardAbout = new Swiper('.SwiperCardAbout', {
  slidesPerView: 1,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false
  },
  pagination: {
    el: ".card-about-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


const SwiperCardOther = new Swiper('.SwiperCardOther', {
  //slidesPerView: 10,
  spaceBetween: 13,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
    draggable: true,
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    991: {
      slidesPerView: 4,
    },
    1199: {
      slidesPerView: 5,
    },
    1920: {
      slidesPerView: 7,
    },
    2400: {
      slidesPerView: 10,
    },
  }
});


const SwiperCardTastes0 = new Swiper('.SwiperCardTastes0', {
  slidesPerView: 1,
  watchOverflow: true,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".card-tastes-pagination-0",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-tastes0-button-next',
    prevEl: '.swiper-tastes0-button-prev',
  },
});

const SwiperCardTastes1 = new Swiper('.SwiperCardTastes1', {
  slidesPerView: 1,
  watchOverflow: true,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".card-tastes-pagination-1",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-tastes1-button-next',
    prevEl: '.swiper-tastes1-button-prev',
  },

});

const SwiperCardTastes2 = new Swiper('.SwiperCardTastes2', {
  slidesPerView: 1,
  watchOverflow: true,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".card-tastes-pagination-2",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-tastes2-button-next',
    prevEl: '.swiper-tastes2-button-prev',
  },

});

const SwiperCardTastes3 = new Swiper('.SwiperCardTastes3', {
  slidesPerView: 1,
  watchOverflow: true,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".card-tastes-pagination-3",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-tastes3-button-next',
    prevEl: '.swiper-tastes3-button-prev',

  },

});

const swiperTastes = document.querySelectorAll(".swiper-tastes");

if ( swiperTastes ) {
  for (var i = 0; i < swiperTastes.length; i++) {
    if ( swiperTastes[i].querySelectorAll(".swiper-slide").length < 2 ) {
      swiperTastes[i].nextElementSibling.classList.add("button-box_hidden");
    }
  }
}




const ageBtn = document.querySelector(".agecheck__btn");
const ageAway = document.querySelector(".agecheck__away");
const ageCheck = document.querySelector(".agecheck");
const ageCheckBlock = document.querySelector(".agecheck__block");

if (swiper) {
  // проверка прелоадера для запуска слайдера
  swiper.autoplay.stop();
  var timeCheck = 0;
  var preLoaderInterval = setInterval(() => {
    timeCheck = +timeCheck + 1;
    console.log(timeCheck);
    if (timeCheck == 6) {
      clearInterval(preLoaderInterval);
    }
  }, 1000);

  // проверка прелоадера для запуска слайдера
}

// ageAway.addEventListener("click", function(){
//   ageCheckBlock.classList.add("agecheck_hidden");
// });

if(localStorage.getItem("agecheck") !== "true"){
  ageCheck.style.display = "flex";
}
ageBtn?.addEventListener("click", function(){

  ageCheck.classList.add("agecheck_hidden");
  localStorage.setItem("agecheck", "true");
  setTimeout(() => {
    ageCheck.style.display = "none";
  }, 400);
});


if (swiper) {
  if (timeCheck == 6) {
    //swiper.autoplay.start();

    if (document.querySelector(".about-us__inner--hidden")) {
      document.querySelector(".about-us__inner--hidden").classList.remove('about-us__inner--hidden');
    }

  } else {
    clearInterval(preLoaderInterval);
    setTimeout(() => {
      // swiper.autoplay.start();

      if (document.querySelector(".about-us__inner--hidden")) {
        document.querySelector(".about-us__inner--hidden").classList.remove('about-us__inner--hidden');
      }

    }, timeCheck * 1000);
  }
}




// Ко второму экрану

/* const toNextScreenBtn = document.querySelector('.next-section-btn');
const achievementsSection = document.querySelector('.achievements');

if (toNextScreenBtn) {
  toNextScreenBtn.addEventListener('click', () => {
    achievementsSection.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  })
} */

const toNextScreenBtnNEW = document.querySelector('.next-section-btn');

const nextSectionClass = document.querySelector(".next-section-btn")?.parentElement?.nextElementSibling?.classList[0];

const nextSection = document.querySelector("." + nextSectionClass);

if (toNextScreenBtnNEW) {
  toNextScreenBtnNEW.addEventListener('click', () => {
    nextSection.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  })
}


let scrollToEl = document.querySelectorAll('.scrollToEl');

if (scrollToEl.length > 0) {
  scrollToEl.forEach(element => {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      if (document.getElementById(element.dataset.to)) {
        document.getElementById(element.dataset.to).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      }
    })

  });
}

document.querySelector("#footer_nav_pertners")?.addEventListener("click", function(){
  if ( location.href.indexOf("buy") > -1 ){
    location.href = "./#callback"
  }
});

document.querySelector("#header_nav_pertners")?.addEventListener("click", function(e){
  if ( location.href.indexOf("partners") > -1 ){
    document.querySelector(".burger__btn").click();
  }
});

setTimeout(() => {
  if ( location.href.indexOf("callback") > -1 ){
    location.href = "#callback_archon";
  }else{
    console.log("none");
  }
}, 6100);


// Подключение анимаций по скроллу
// import AOS from 'aos';
// AOS.init();

// Подключение параллакса блоков при скролле
// import Rellax from 'rellax';
// const rellax = new Rellax('.rellax');

// Подключение плавной прокрутки к якорям
// import SmoothScroll from 'smooth-scroll';
// const scroll = new SmoothScroll('a[href*="#"]');

// Подключение событий свайпа на мобильных
// import 'swiped-events';
// document.addEventListener('swiped', function(e) {
//   console.log(e.target);
//   console.log(e.detail);
//   console.log(e.detail.dir);
// });

// import { validateForms } from './functions/validate-forms';
// const rules1 = [...];

// const afterForm = () => {
//   console.log('Произошла отправка, тут можно писать любые действия');
// };

// validateForms('.form-1', rules1, afterForm);




// Создание сцены и загрузка текстур
//const app = new PIXI.Application({ width: window.innerWidth, height: window.innerHeight, transparent: true, BackgroundAlpha: 0, useContextAlpha: true  });



let marqueeList = document.querySelectorAll('.marquee');
console.log(marqueeList);

marqueeList.forEach(marqueeEl => {
  new marquee(marqueeEl, {
    duplicated: true,
    gap: 10,
    speed: 30,
  });

});




const shopBtn = document.querySelector('.shop-message__btn');
const shopForm = document.querySelector(".graph-modal__form");
const shopSuccess = document.querySelector(".graph-modal__success");
const shopClose = document.querySelector(".graph-modal__close");

// shopBtn.addEventListener("click", function(e){
//   e.preventDefault()

//   shopForm.classList.add("graph-modal__form_hidden");
//   shopSuccess.classList.add("graph-modal__success_open");

//   setTimeout(() => {
//     shopForm.submit();
//   }, 100000);
  
// });

if(shopClose){
  shopClose.addEventListener("click", function(e){

    shopForm.classList.remove("graph-modal__form_hidden");
    shopForm.reset();
    shopSuccess.classList.remove("graph-modal__success_open");
    
  });
}




async function sendAjax(formData) {
  let response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST', body: formData,
  });
  let result = await response.json();
  return result;
}



const openModal = (modalName) => {
    let body = document.querySelector('body');
    let container = document.querySelector('.graph-modal');

    if (!body.classList.contains('disable-scroll')) body.classList.add('disable-scroll');

    if (!container.classList.contains('is-open')) container.classList.add('is-open');

    document.querySelectorAll('.graph-modal__container')?.forEach(modal => {
        modal.classList.remove('graph-modal-open', 'fade', 'animate-open');
    });

    document.querySelector(`.graph-modal__container[data-graph-target=${modalName}]`).classList.add('graph-modal-open', 'fade', 'animate-open');
};

const closeModals = () => {
    let body = document.querySelector('body');
    let container = document.querySelector('.graph-modal');

    if (body.classList.contains('disable-scroll')) body.classList.remove('disable-scroll');

    if (container.classList.contains('is-open')) container.classList.remove('is-open');

    document.querySelectorAll('.graph-modal__container')?.forEach(modal => {
        modal.classList.remove('graph-modal-open', 'fade', 'animate-open');
    });
};

shopForm?.addEventListener('submit', (e) => {
    e.preventDefault();

    let formData = new FormData(e.target);
    sendAjax(formData).then(result => {
        shopForm.classList.add("graph-modal__form_hidden");
        shopSuccess.classList.add("graph-modal__success_open");
      // shopForm.classList.remove("graph-modal__form_hidden");
      // shopSuccess.classList.remove("graph-modal__success_open");

    })
});